/*
 * Copyright (c) 2020-2026  Apricad LLC. All Rights Reserved.
 */

// For failed result messages, the name must end with "Fail"

const sTryAgain = "Please try again later.";

// Landing
//
export const sLandingCatch =
  " This website is dedicated to those who will be, have been and once were nurses.";
// Why Take...
export const sWhy = "Why take Apricad courses?";
export const sWhyMsg = `Online nursing courses can be <b>free</b> as well as of <b>high quality</b>.  At Apricad we strive for both. <br/>Our courses and lectures are created and reviewed by healthcare professionals. Lists of references are provided in lectures and handouts.`;
export const sWho = "Who can use Apricad courses?";
export const sWhoS =
  "<ul><li>Theory and evidence-based courses/lectures.</li><li>Save time, energy, and money.</li><li>Versatile teaching, learning methods, and materials incorporated to suit each individual’s learning style.</li><ul>";
export const sWhoN =
  "<ul><li>Refresh nursing knowledge with theory and evidence-based courses and lectures.</li><li>Support nursing practice with updated information.</li><li>Take you back to the memorable time of being a nursing student.</li></li></ul>";
export const sWhoI =
  "<ul><li>Free access to reliable teaching materials.</li><li>Compact courses designed to be informative and concise.</li><li>Relevant information based on current source and is reviewed by healthcare professionals.</li></ul>";
// How Apricad works
export const sWhat = "What does Apricad offer?";
export const sEnrollN = "Free Enrollment";
export const sEnrollMsg =
  "By registering on Apricad.com, and subscribing to our YouTube channel, you can enroll in courses with rich materials and features, free of charge!";
export const sClassroom = "Compact Courses, Short Lectures";
export const sClassroomMsg =
  "Free access to compact courses and short lectures with theory and evidence-based information to supplement learnings from nursing school.";
export const sClipbrd = "Various Learning Methods";
export const sClipbrdMsg =
  "Students learn best via different learning methods. Apricad offers assorted teaching-learning methods in our classroom, including video, handout, flashcard, and tests.";
export const sNotes = "Note-Taking with Video Bookmark";
export const sNotesMsg =
  "Note-taking promotes active thinking and enhances knowledge retention. You can also add video bookmarks for quick reference.";

// Footer
export const sContactUs = "Contact Us";
export const sEmailContact = "apricot.op1@gmail.com";
export const sChannel = "https://www.youtube.com/c/ApricadCoursesofNursing";
export const sContactMsg = `Whether for our courses content or user experience, we would love to have your feedback! Please <a href="/sup/surv" style="color:#E98D24"><b>Give Feedback</b></a> or leave comments at <a href=${sChannel} style="color:#E98D24"><b>Our Channel</b></a>.`;
export const sDisclaimer =
  "To the fullest extent of the law, neither the website owners, creators, content contributors, nor technical personnel assume any liability for injury, harm, or loss to person or property as a result of individual’s reliance on the information or features provided by this site.";

// Account General
//
export const sLogin = "LOG IN";
export const sSignup = "SIGN UP";
export const sProceed = "Proceed";
export const sResendCode = "Request New Code";
export const sRetry = "Try Again";
export const sOrByMail = "Or by Email";
export const sBySocial = "by your account on...";
export const sStart = "Login / Sign-up";
export const sBack = "Back";
export const sCancel = "Cancel";
export const sTryLater = "Try Again Later";
export const sSubmit = "Submit";
export const sDiscard = "Discard";
export const sLogo = "Courses of Nursing";
export const sCannotUndo =
  "This cannot be undone. Are you sure you want to proceed?";
export const sImSure = "Yes, I'm sure.";
export const sNotAvail = "Action Required";

// SignIn Page
export const sFreeAcnt = "Free Apricad Account";
export const sFreeAcntMsg =
  "Sign up for free access to all content in Apricad.";
export const sNtsVideo = "Video & Note Taking";
export const sNtsVideoMsg =
  "Study on the go. You can take notes as you watch the video. The notes also serve as video bookmarks for quick reference.";
export const sClipbrdMsg2 =
  "A full learning experience is enriched with handouts, flashcards, assignments, and tests.";
export const sTests = "Tests";
export const sTestsMsg =
  "You can find some small quizzes for an individual lecture or a test after you complete a course. Multiple formats are incorporated in the test. Test items can be multiple choice, multiple selections, fill in the blank, reordering and categorizing. Each test is scored and timed, and can only be taken once for each account. ";

// Sign Up Dialog
export const sNoAccount = "Don't Have an Account?";
export const sGotAccount = "Already Have an Account?";
export const sLegal = "Legal Notices";
export const sBadSignIn =
  "The account doesn't have the information required, such as an email address.";

// Login Dialog
export const sLoginFail = "Sign-In Failed";
export const sLoginFailMsg =
  "Either the email or password is incorrect. Please try again or reset the password.";
export const sConfirmEmail = "Email Address Confirmation";
export const sConfirmEmailMsg =
  "Your email address is not confirmed. Press PROCEED to request a confirmation link via email, then check your mailbox, including your <span style='font-weight:700; color:red;'>spam/junk</span> folder.";
export const sForgotPW = "Forgot Password?";
export const sVerifyReqFail = "Verification Request Failed";
export const sVerifyReqFailMsg = `Cannot request a new verification email. ${sTryAgain}`;

// Reset Dialog
export const sResetPassword = "Reset Password";
export const sConfirmSendCode =
  "Please confirm your email address if you would like to proceed. A verification code will be sent to this email address.";
export const sResetInfo =
  "We have sent you a verification code. Check your inbox, including your <span style='font-weight:700; color:red;'>spam/junk</span> folder. Enter the code and the new password.";
export const sResetOk = "Password Reset Successfully";
export const sResetOkMsg = "Please log in with the new password.";
export const sResetFail = "Password Reset Failed";
export const sResetFailMsg = "Cannot reset password, please try again.";
export const sResetInfoFail =
  "There is no user signed up with this email address. Please confirm the correct email or if you signed up with social media.";
export const sCodeMatchFail =
  "This verification code is incorrect. Please try again.";

// Change Password Dialog
export const sChgPW = "Change Password";
export const sChgPWMsg = "Please enter the old and new password.";
export const sErrTwoPW = "Retyped password mismatch.";
export const sChgOK = "Password is changed successfully.";
export const sOldPWWrong = "Please enter the correct old password.";

// Sign Up Dialog
export const sCreateUser = "CREATE ACCOUNT";
export const sSignUpUser = "SIGN UP";
export const sSignUpUser2 = "Sign Up New Account";
export const sSignUpFail = "Sign Up Failed";
export const sBySignUp = "By signing up, I agree to the";
export const sNewUserFail =
  "An account with the given email already exists. Please sign up with a different email address.";
export const sSignUpFailMsg = `Cannot sign up. Please confirm your email address is correct.`;
export const sVerifyMailSent =
  "We have sent you a confirmation link to your email address. If you find it in your <span style='font-weight:700; color:red;'>spam</span> folder, please move it to the inbox before clicking the link.";
export const sTerms = "Terms of Use";
export const sPolicy = "Privacy Policy";

// Welcome Page
export const sWelcome =
  "Please also subscribe to our YouTube channel to support us.";
export const sByStart = "By starting to use this website, you agree to the";
export const sHowFound = "How did you hear about us?";
export const sUpdateProfile =
  "You can update the job(s) or add interested area(s) later in your profile under header menu.";
export const sJobsRequired =
  "This information will help us tailor content to better meet your needs."; // if user doesn't choose his/her job.
export const sHowfRequired =
  "Your answer can help more people utilize our courses."; // if user doesn't choose How found us.

// Form general
export const sRadioErr = "Please choose an answer.";
// validation text
export const sPWRequired = "Password is required.";
export const sPWRule =
  "Length: 8~32. Use upper & lower case, a number and a symbol (!@#$%^&*)";
export const sEmailRequired = "Email address is required.";
export const sNameRequired = "Please provide a display name.";
export const sMaxName = "Can we call you with a shorter name?"; // if user type a name longer than 40 characters
export const sMinName = "A name needs at least two letters.";
export const sCodeRequired = "Please enter the code you received by email.";
export const sAgreRequired = "Please accept the terms and policy.";

// Cart
// export const sAddCart = "Course is added to the cart.";
// export const sDeleteCart = "Course is removed from the cart.";
// export const sUpdateCartFail = `Cannot update the cart at the moment. ${sTryAgain}`;
// export const sAccessCartFail = `Cannot retrieve the cart at the moment. ${sTryAgain}`;
// export const sCheckout = "Checkout";
// export const sCheckoutFail = `Cannot complete enrollment process. ${sTryAgain}`;
// export const sDonePurchase = "Complete Enrollment";

// User / Profile
export const sMyProfile = "My Profile";
export const sYourJob = "Your occupation:";
export const sYourAreas = "Area(s) of interest:";
export const sProfileOk = "User profile updated.";
export const sProfileFail = `Cannot update your profile. ${sTryAgain}`;
export const sDeleteUserOk = "User account is deleted.";
export const sDeleteUserFail = `Cannot delete user account. ${sTryAgain}`;
export const sDeleteAccount = "Delete Account";
export const sDeleteAccountMsg =
  "(Incomplete) All courses acquired and notes taken can no longer be accessed after deletion. Please type in your %1$s to confirm.";
export const sDelAccountFail = "Cannot delete account";
export const sDelAccountFailMsg =
  "Please try again with the correct information.";
export const sSubmitChange = "Submit Change";
export const sChangeName = "Change Name";

// Course / Classroom / MyStudy
export const sMyStudy = "My Study";
export const sStudyEnroll =
  "MyStudy is where you can access the resources of the courses enrolled in. Please enroll in one of our courses first. The enrollment is free.";
export const sMyNotes = "My Notes";
export const sGoToCourse = "Go to Course Page";
export const sGoToLec = "Go to Lecture";
export const sBkToStudy = "Back to My Study";
export const sGetLicDocFail = `Cannot retrieve information now. ${sTryAgain}`;
export const sShareMsg = "Check out this cool Nursing course!";
export const sEnrollDlgMsg =
  "It is free of charge to enroll in the course. After enrolling, you can reference handouts, take the tests or assignments, track your video progress, and take notes (with video bookmarks).";
export const sPubCmt =
  "Please leave a public comment in our YouTube video page. You can find the page of the specific video, if any, in the PLAYLIST.";
export const sPriCmt = "You can also give us feedback privately.";

// Notes
export const sDelNote = "Delete Note";
export const sAccessNoteFail = `Cannot access the notes storage at the moment. ${sTryAgain}`;
export const sPlay = "Play";
export const sUpdateVB = "Set video bookmark";
export const sClearVB = "Remove video bookmark";
export const sNotesCover2 = "with Video Bookmark";
export const sNewNote = "Add a new note";
export const sExpandAll = "Expand all notes";
export const sFoldupAll = "Collapse all notes";
export const sEnlargeNZ = "Enlarge notes zone";
export const sReduceNZ = "Reduce notes zone";
export const sOpenNotes = "Open Notes";
export const sAddNote = "Add a Note";
export const sNoteLabel = "Enter label of the note/bookmark";
export const sNoteText = "Enter content of the note";
export const sOverLimit = "Exceed Limit";
export const sTooManyNts = "You cannot add more than 30 notes under a lecture.";

// Posts
export const sPostHere = "Post your comment...";
// export const sDelPost = "Remove Post";
// export const sPostRemoved = "The content of this post has been removed.";
// export const sViewReply = "View Replies";
// export const sReply = "Reply";

// Test
export const sQuitTest = "Quit now?";
export const sQuitTestMsg =
  "It will be considered failed if you quit before completing. Are you sure you want to proceed?";
export const sTestConfirm = "I have completed the related lecture(s).";
export const sAnsShowAbove = "The correct answer is shown as above.";
export const sRightAns = "The correct answer is:";
export const sSkipped = "You skipped this item.";
export const sAnsCorrect = "Your answer is incorrect.";
export const sExFeedback = "Feedback from the Instructor:";
export const sExThink = "Critical Thinking:";

// Feedback
export const sGiveFeedback = "Give Feedback";
export const sSurveyOK =
  "Survey data has been submitted. Thank you for the feedback!";
export const sSurveyFail = `Survey data cannot be submitted now. ${sTryAgain}`;
// choice questions
export const sSurvQ1 =
  "How helpful are our courses to you? 5 means very helpful.";
export const sSurvQ2 =
  "How smooth is your studying experience with apricad.com? 5 means very smooth.";
export const sSurvCmt1 = "What worked well for you?";
export const sSurvCmt2 = "What are your suggestions to make this site better?";
export const sSurvCmt3 = "Do you have any other feedback?";

// Support Us
export const sSupportUs = "Support Us";
export const sSupUs1 =
  "We hope you enjoy our hand-crafted materials. Together, we can help our nurses on the frontline protect everybody.";
export const sSupUs2 =
  "You can support us by subscribing to our channel, giving us feedback, or sharing Apricad with people.";
export const sSupUs3 = "Or, buying Ms. Apricad a cup of coffee...";
export const sSecPay =
  "Your card and billing information, required by the payment gateway (PayPal), are not seen or stored by Apricad.";
export const sChgDonate = "Change Donation"; // to change a different amount
export const sShare = "Share";

// actions
// - Course/Lecture/Own
export const sAccessCourseFail = "Error when accessing the course data.";
// for feature just needs login (no enroll required), such as Post
export const sNeedLogin = "You need to login to use this feature.";
// for click Enroll (in CourseAction) w/o login
export const sLoginForEnroll = "You need to login to enroll in the course.";
// for features need login/enroll
export const sNeedLoginAndEnroll = `This feature is available after you login and enroll in the course. The enrollment is <b><span style="color:#E98D24">free of charge</span></b>.`;
export const sNeedEnroll =
  "This feature is available after you enroll in the course.";
export const sEnrollOk = "You've enrolled in the course successfully.";
export const sEnroll = "Enroll Free";
export const sAgreeEnroll = "Agree and Enroll";

// Preview
export const sPreview = "For Preview Only";
export const sPreviewMsg =
  "Please enter the preview code and sign in again. By entering this code, you agree to the terms of use and privacy policy in our legal term pages.";
